import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ScreenClassRender } from "react-grid-system";
import HeaderV2 from "../../components/headerV2";
import PeriodoSelector from '../../components/relatorios/periodo-selector';
import { formatDate } from '../../services/formatDate';
import { RelatorioContainer } from "./styles";
import AlvosMaisFrequentesPorPeriodo from '../../components/relatorios/alvos-frequentes-por-periodo';
import ProdutosMaisFrequentesPorPeriodo from '../../components/relatorios/produtos-frequentes-por-periodo';
import {
    StatCol,
    StatsRow,
    DashboardCols,
    MainCol,
    SideCol,
    IndicatorsCard,
    IndicatorsTitle,
    IndicatorsCols,
    IndicatorCol,
} from './styles';
import CulturasMaisFrequentesPorPeriodo from '../../components/relatorios/culturas-frequentes-por-periodo';
import TotalAreaTratada from '../../components/relatorios/total-area-tratada';
import QtdReceitasEmitidas from '../../components/relatorios/qtd-receitas-emitidas';
import ClientesAtendidos from '../../components/relatorios/clientes-atendidos';
import CalendaryCampMetric from '../../components/CalendaryCampMetric';
import GraphicReview from '../../components/GraphicReview';
import GraphicOverviewMetric from '../../components/GraphicOverviewMetric';
import CadastrosResumo from '../../components/relatorios/cadastros-resumo';
import RankingReport from '../../components/RankingReport';

// Período padrão ao abrir a tela pela primeira vez (sem nada salvo na URL):
// últimos 12 meses - bate com o que a maioria dos cards já usava como
// padrão individual.
const getPeriodoPadrao = () => {
    const hoje = new Date();
    const umAnoAtras = new Date(new Date().setDate(hoje.getDate() - 365));
    return {
        dtInicial: umAnoAtras.toISOString().slice(0, 10),
        dtFinal: hoje.toISOString().slice(0, 10),
    };
};

const Historico = ({ ...props }) => {
    const history = useHistory();
    const location = useLocation();

    const [screenSize, setScreenSize] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [load, setLoad] = useState(false)

    // Período global - governa todos os cards da tela. Lido da URL no
    // primeiro load (persiste em refresh/navegação, é compartilhável), com
    // fallback pro padrão de 12 meses.
    const [periodo, setPeriodo] = useState(() => {
        const params = new URLSearchParams(location.search);
        const dtInicial = params.get('dtInicial');
        const dtFinal = params.get('dtFinal');
        return (dtInicial && dtFinal) ? { dtInicial, dtFinal } : getPeriodoPadrao();
    });

    // Mantém a URL sincronizada com o período selecionado - replace (não
    // push) pra não empilhar uma entrada no histórico a cada troca de data.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set('dtInicial', periodo.dtInicial);
        params.set('dtFinal', periodo.dtFinal);
        history.replace({ search: params.toString() });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [periodo]);

    const { dtInicial, dtFinal } = periodo;
    const periodoLabel = useMemo(
        () => `${formatDate(periodo.dtInicial)} – ${formatDate(periodo.dtFinal)}`,
        [periodo]
    );

    const handleChangePeriodo = (novoDtInicial, novoDtFinal) => {
        setPeriodo({ dtInicial: novoDtInicial, dtFinal: novoDtFinal });
    };

    const getScreenSize = screensize => {
        setLoad(true);
        const sizesToHide = ["xl", "lg"];
        const hide = sizesToHide.includes(screensize);
        const prevScreenSize = screenSize;

        if (prevScreenSize !== screensize) {
            if (hide) {
                setScreenSize(screensize);
                setIsMobile(false);

            } else {
                setScreenSize(screensize);
                setIsMobile(true);
            }
        }
    };

    return (

        <ScreenClassRender
            render={screenClass => (<>
                <HeaderV2
                    title="Relatórios"
                    rightSlot={
                        <PeriodoSelector
                            dtInicial={dtInicial}
                            dtFinal={dtFinal}
                            onChange={handleChangePeriodo}
                        />
                    }
                />

                <RelatorioContainer isMobile={isMobile} style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '16px' }}>
                    {load === false ? getScreenSize(screenClass) : null}

                    <StatsRow>
                        <StatCol>
                            <QtdReceitasEmitidas dtInicial={dtInicial} dtFinal={dtFinal} />
                        </StatCol>
                        <StatCol>
                            <TotalAreaTratada dtInicial={dtInicial} dtFinal={dtFinal} />
                        </StatCol>
                        <StatCol>
                            <ClientesAtendidos dtInicial={dtInicial} dtFinal={dtFinal} />
                        </StatCol>
                    </StatsRow>

                    <DashboardCols>
                        <MainCol>
                            <GraphicReview dtInicial={dtInicial} dtFinal={dtFinal} />
                        </MainCol>

                        <SideCol>
                            <GraphicOverviewMetric dtInicial={dtInicial} dtFinal={dtFinal} periodoLabel={periodoLabel} />
                            <CadastrosResumo dtInicial={dtInicial} dtFinal={dtFinal} periodoLabel={periodoLabel} />
                            <CalendaryCampMetric dtInicial={dtInicial} dtFinal={dtFinal} periodoLabel={periodoLabel} />
                        </SideCol>
                    </DashboardCols>

                    <IndicatorsCard>
                        <IndicatorsTitle>Indicadores mais frequentes (%)</IndicatorsTitle>
                        <IndicatorsCols>
                            <IndicatorCol>
                                <AlvosMaisFrequentesPorPeriodo dtInicial={dtInicial} dtFinal={dtFinal} />
                            </IndicatorCol>
                            <IndicatorCol>
                                <CulturasMaisFrequentesPorPeriodo dtInicial={dtInicial} dtFinal={dtFinal} />
                            </IndicatorCol>
                            <IndicatorCol>
                                <ProdutosMaisFrequentesPorPeriodo dtInicial={dtInicial} dtFinal={dtFinal} />
                            </IndicatorCol>
                        </IndicatorsCols>
                    </IndicatorsCard>

                    <RankingReport dtInicial={dtInicial} dtFinal={dtFinal} periodoLabel={periodoLabel} />
                </RelatorioContainer>
            </>)}
        />);
};


export default Historico;
